import React, { createContext, useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import CONFIG from '../config/Config';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [userToken, setUserToken] = useState(null);

  // Uygulama açıldığında hafızada token var mı kontrol et
  const checkToken = async () => {
    try {
      let token = await AsyncStorage.getItem('userToken');
      setUserToken(token);
    } catch (e) {
      console.log(`Token okuma hatası: ${e}`);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    checkToken();
  }, []);

  const login = async (username, password) => {
    setIsLoading(true);
    
    try {
      // JSON yerine Form verisi oluşturuyoruz
      let formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);

      const response = await fetch(`${CONFIG.API_BASE_URL}/login`, {
        method: 'POST',
        // DİKKAT: FormData kullanırken 'Content-Type' başlığını BİZ YAZMIYORUZ. 
        // Fetch bunu otomatik olarak 'multipart/form-data' şeklinde ayarlar.
        headers: {
          'Accept': 'application/json',
          'X-App-Env': CONFIG.ENV
        },
        body: formData // stringify yerine doğrudan formData objesini veriyoruz
      });

      const result = await response.json();
      console.log("Sunucu Cevabı:", result);

      if (result.success) { 
        const userDataString = JSON.stringify(result.user);
        setUserToken(userDataString);
        await AsyncStorage.setItem('userToken', userDataString);
      } else {
        alert('Hata: ' + (result.message || 'Giriş başarısız!'));
      }

    } catch (error) {
      console.log("API Bağlantı Hatası:", error);
      alert('Sunucuya ulaşılamıyor! İnternet bağlantınızı kontrol edin.');
    }

    setIsLoading(false);
  };

  const logout = async () => {
    setIsLoading(true);
    setUserToken(null);
    await AsyncStorage.removeItem('userToken');
    setIsLoading(false);
  };

  return (
    <AuthContext.Provider value={{ login, logout, isLoading, userToken }}>
      {children}
    </AuthContext.Provider>
  );
};